import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import CharacterRoleIcon from 'app/frontend/base/components/CharacterRoleIcon'
import BlizzardIcon from 'app/frontend/base/components/BlizzardIcon'
import { CharacterClassIcon } from 'app/frontend/base/components'
import { CharacterClass } from 'app/frontend/types/custom'
import { ReactNode } from 'react'
import { SpecializationOption } from '../hooks/useTeamPlanComputedData'

type ActorSpecializationGroup = {
  classId: number
  className: string
  specializations: SpecializationOption[]
}

type ActorSpecializationMenuProps = {
  group: ActorSpecializationGroup
  trigger: ReactNode
  onSelectClass: (classId: number, className: string) => void
  onSelectSpecialization: (spec: SpecializationOption) => void
  align?: 'start' | 'center' | 'end'
  onOpenChange?: (open: boolean) => void
}

const ActorSpecializationMenu = ({
  group,
  trigger,
  onSelectClass,
  onSelectSpecialization,
  align = 'start',
  onOpenChange,
}: ActorSpecializationMenuProps) => {
  return (
    <DropdownMenu onOpenChange={onOpenChange}>
      <DropdownMenuTrigger asChild>{trigger}</DropdownMenuTrigger>
      <DropdownMenuContent align={align}>
        <DropdownMenuItem
          onClick={() => onSelectClass(group.classId, group.className)}
        >
          <div className='flex items-center gap-2 w-full'>
            <CharacterRoleIcon role={'damage'} className='invisible' />
            <CharacterClassIcon
              characterClass={group.className as CharacterClass}
            />
            <span>{group.className}</span>
          </div>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        {group.specializations.map((spec) => (
          <DropdownMenuItem
            key={spec.id}
            onClick={() => onSelectSpecialization(spec)}
          >
            <div className='flex items-center gap-2 w-full'>
              <CharacterRoleIcon role={spec.defaultRole} />
              <BlizzardIcon iconName={spec.icon} />
              <span>{spec.name}</span>
            </div>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export type { ActorSpecializationGroup }
export default ActorSpecializationMenu
